import {observer} from 'mobx-react-lite'
import platform from 'platform'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Link} from '@components/common/button/button'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {
  DownloadAppContext,
  DownloadAppStore,
  useDownloadAppStore
} from './download-app-store'
import LinuxIcon from './icon-linux.svg'
import MacIcon from './icon-mac.svg'
import WinIcon from './icon-win.svg'
import YouGileLogoIcon from './icon-yougile-logo.svg'

export const DownloadApp = () => {
  const [store] = useState(() => new DownloadAppStore())

  return (
    <DownloadAppContext.Provider value={store}>
      <DownloadAppBase />
    </DownloadAppContext.Provider>
  )
}

const TwIcon = tw.div`
  mx-24
  leading-6
  items-center
  flex
  gap-8
  cursor-pointer
  text-third-old
  hover:text-action-hover
  active:text-action-pressed
`

const getCurrentIcon = () => {
  const family = platform.os?.family?.toLowerCase() ?? ''
  if (family.includes('mac') || family.includes('os x')) {
    return <MacIcon />
  } else if (family.includes('linux')) {
    return <LinuxIcon />
  } else {
    return <WinIcon />
  }
}

// eslint-disable-next-line max-lines-per-function
const DownloadAppBase = observer(() => {
  const [state, store] = useDownloadAppStore()
  useSyncEventUpdateEffect('profile', {
    debounceTime: 50,
    filter: globals.currentUserId
  })

  return (
    <div className="flex justify-between min-w-486">
      {!state.showOthers ? (
        <div className="flex flex-col justify-end">
          <div className="flex items-center mb-16">
            <div className="flex gap-8 text-action-default hover:text-action-hover active:text-action-pressed">
              <span className="text-third-old">{getCurrentIcon()}</span>
              <Link onClick={() => store.download('auto')}>
                {Lang.msg.profilePage.downloadForYourOS}
              </Link>
            </div>
          </div>

          <Link onClick={() => store.setShowOthers(true)} className="ml-23">
            {Lang.msg.profilePage.otherOS}
          </Link>
        </div>
      ) : (
        <div className="flex flex-wrap items-center ml-28">
          <TwIcon onClick={() => store.download('win64')}>
            <WinIcon />
            Windows x64
          </TwIcon>
          <TwIcon onClick={() => store.download('win32')}>
            <WinIcon />
            Windows x32
          </TwIcon>
          <TwIcon onClick={() => store.download('linux')}>
            <LinuxIcon />
            Linux
          </TwIcon>
          <TwIcon onClick={() => store.download('mac')}>
            <MacIcon />
            MacOS
          </TwIcon>
        </div>
      )}
      <div
        onClick={() => store.download('auto')}
        className="cursor-pointer shadow-lg rounded-17"
      >
        <YouGileLogoIcon />
      </div>
    </div>
  )
})
